"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.responseSchema = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({ lngLat: zod_1.z.string() });
exports.responseSchema = zod_1.z.boolean();
exports.path = '/soil-calibration-good-readings-delete';
//# sourceMappingURL=index.js.map